//=====================================================
//　パスワードテキストボックス
//=====================================================
import { InputTag } from '../utils/ConstCommon';
import { getMsg, ConstMsg } from '../utils/ConstMsg';
import { InputPasswordBase } from './InputPasswordBase';
import { LblInput } from './LblInput';
import { ValidErrMsgInline } from './ValidErrMsgInline';

interface IFProps {
    name: string
}

const FORM_TITLE = 'パスワード';

export function TxtLoginPassword(props: IFProps) {
    
    //バリデーション
    const validations = {
        required: getMsg(ConstMsg.EG0080001, [FORM_TITLE]),
        pattern: {value: /^[0-9a-zA-Z-]+$/, message: getMsg(ConstMsg.EG0080002, [FORM_TITLE])},
        maxLength: {value: 256, message: getMsg(ConstMsg.EG0080004, [FORM_TITLE, '256'])}
    }

    return (
        <div className='input-box'>
            <LblInput title={FORM_TITLE} tag={InputTag.Required} />
            <ValidErrMsgInline name={props.name}/>
            <div className='input-login-password'>
                <InputPasswordBase name={props.name} className='input-text-login-password' validations={validations}/>
            </div>
            <div className='input-supple'>
                <div>※初回ログインのパスワードは、患者様の生年月日8桁です。</div>
                <div>例）1980年1月30日→19800130</div>
            </div>
        </div>
    )

}

